/* =====================================================================
   Menopause Made Me Say It — custom theme JS
   Announcement rotator · header scroll blur · review carousel · quick-add AJAX
   Progressive enhancement only. Every feature degrades gracefully.
   Reads Horizon's `Theme` global for cart routes.
   ===================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ----------------------------------------------------------
  // Announcement rotator
  // Cycles through [data-mmmsi-announcement] children every 4.2s.
  // ----------------------------------------------------------
  function initAnnouncementRotator() {
    var root = document.querySelector('[data-mmmsi-announcement-rotator]');
    if (!root) return;
    var items = root.querySelectorAll('[data-mmmsi-announcement-item]');
    if (items.length < 2 || reducedMotion) return;

    // Dot cycles through clay → sage → wine → blush as messages advance
    var dotColors = ['#DC96B5', '#A3B09A', '#7D2A3C', '#F8D6DE'];
    var dot = root.querySelector('.mmmsi-announcement__dot');

    var idx = 0;
    items.forEach(function (el, i) { el.hidden = i !== 0; });

    setInterval(function () {
      items[idx].hidden = true;
      idx = (idx + 1) % items.length;
      var next = items[idx];
      next.hidden = false;
      next.classList.remove('mmmsi-announcement__message--enter');
      // force reflow to restart the animation
      void next.offsetWidth;
      next.classList.add('mmmsi-announcement__message--enter');

      if (dot) {
        dot.style.backgroundColor = dotColors[idx % dotColors.length];
      }
    }, 4200);
  }

  // ----------------------------------------------------------
  // Header scroll blur
  // Adds .is-scrolled when scrollY > 20
  // ----------------------------------------------------------
  function initHeaderScroll() {
    var header = document.querySelector('[data-mmmsi-header]');
    if (!header) return;
    var apply = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    apply();
    window.addEventListener('scroll', apply, { passive: true });
  }

  // ----------------------------------------------------------
  // Review carousel
  // [data-mmmsi-reviews-carousel] with child [data-mmmsi-review] items
  // and [data-mmmsi-review-prev] / [data-mmmsi-review-next] buttons.
  // ----------------------------------------------------------
  function initReviewCarousel() {
    document.querySelectorAll('[data-mmmsi-reviews-carousel]').forEach(function (root) {
      var items = root.querySelectorAll('[data-mmmsi-review]');
      if (items.length < 2) return;
      var prev = root.querySelector('[data-mmmsi-review-prev]');
      var next = root.querySelector('[data-mmmsi-review-next]');
      var idx = 0;

      function show(i) {
        items.forEach(function (el, j) {
          el.hidden = j !== i;
          if (j === i) {
            el.classList.remove('mmmsi-announcement__message--enter');
            void el.offsetWidth;
            el.classList.add('mmmsi-announcement__message--enter');
          }
        });
      }
      show(0);

      if (prev) prev.addEventListener('click', function () {
        idx = (idx - 1 + items.length) % items.length;
        show(idx);
      });
      if (next) next.addEventListener('click', function () {
        idx = (idx + 1) % items.length;
        show(idx);
      });
    });
  }

  // ----------------------------------------------------------
  // Quick-add by size
  // Buttons with [data-mmmsi-quick-add-variant] carry the variant ID.
  // Posts to Theme.routes.cart_add_url with JSON.
  // ----------------------------------------------------------
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mmmsi-quick-add-variant]');
      if (!btn) return;
      var variantId = btn.getAttribute('data-mmmsi-quick-add-variant');
      if (!variantId) return;
      e.preventDefault();
      e.stopPropagation();

      var cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url)
        || '/cart/add.js';

      btn.disabled = true;
      var originalLabel = btn.textContent;
      btn.textContent = '...';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.textContent = '✓';
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
        setTimeout(function () {
          btn.textContent = originalLabel;
          btn.disabled = false;
        }, 1200);
      })
      .catch(function () {
        btn.textContent = originalLabel;
        btn.disabled = false;
      });
    });
  }

  // ----------------------------------------------------------
  // Cart drawer open trigger
  // Any [data-mmmsi-cart-open] element opens the drawer; custom event.
  // ----------------------------------------------------------
  function initCartOpeners() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-mmmsi-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('mmmsi:cart:open'));
    });
  }

  // ----------------------------------------------------------
  // Boot
  // ----------------------------------------------------------
  function boot() {
    initAnnouncementRotator();
    initHeaderScroll();
    initReviewCarousel();
    initQuickAdd();
    initCartOpeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init after Horizon section-renderer swaps content (theme editor / navigation)
  document.addEventListener('shopify:section:load', boot);
})();
